/**
 * Das Sicherungsformat und seine Validierung.
 *
 * Das ist eine der drei Systemgrenzen des Projekts (die anderen beiden sind die
 * Wetter- und die Feiertagsquelle). Validiert wird mit zod - das Schema selbst
 * liegt aber in `schema.ts`, damit diese Datei OHNE zod auskommt.
 *
 * Der Grund ist die Buendelgroesse: zod kostet rund 26 kB gzip. Es wird nur
 * beim IMPORT einer Sicherung gebraucht, und der laeuft ausschliesslich in den
 * Einstellungen. Wuerde hier statisch `zod` importiert, landete es im
 * Hauptbuendel und jeder Erststart bezahlte dafuer.
 */
import { CURRENT_SCHEMA_VERSION } from '@/domain/types';
import { DATA_TABLE_NAMES } from '@/db/schema';

export const APP_MARKER = 'ole-privat';

/** Roh-Form waehrend der Migration, bevor final validiert wird. */
export interface RawDump {
  schemaVersion: number;
  data: Record<string, Record<string, unknown>[]>;
  [key: string]: unknown;
}

export class BackupError extends Error {
  constructor(
    message: string,
    readonly kind:
      | 'not_our_file'
      | 'too_new'
      | 'no_migration'
      | 'count_mismatch'
      | 'invalid',
    readonly detail?: number,
  ) {
    super(message);
    this.name = 'BackupError';
  }
}

/** Gesamtzahl der Zeilen ueber alle Tabellen - fuer Dialoge und Pruefsumme. */
export function totalRows(counts: Record<string, number>): number {
  return Object.values(counts).reduce((sum, n) => sum + n, 0);
}

export function countRows(data: Record<string, unknown[]>): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const name of DATA_TABLE_NAMES) {
    counts[name] = data[name]?.length ?? 0;
  }
  return counts;
}

export { CURRENT_SCHEMA_VERSION };
